module.exports = __webpack_public_path__ + "static/media/copyToClipboard.2fec4b98.svg";